import { Timestamp } from 'firebase/firestore';

/**
 * Update-Daten für "Fahrt zurücknehmen" (pre_accepted → scheduled) — identisch
 * für Fahrtdetails und LiveMap, damit beide Wege denselben sauberen Zustand
 * hinterlassen (inkl. Dispatch-Angebotsresten).
 *
 * `dispatcherReleasedAt` markiert die Rücknahme als Disponenten-Aktion: Die
 * Cloud Function E10 (createPortalRideStatusNotifications) unterdrückt damit
 * die "Vorbestellung wieder ohne Fahrer — von Fahrer zurückgegeben"-Meldung,
 * die sonst fälschlich für die eigene Aktion erzeugt würde.
 */
export const buildDispatcherReleaseData = () => ({
  driverId: null,
  driverName: null,
  driverProfilePic: null,
  driverRating: null,
  driverRatingCount: null,
  driverModel: null,
  driverLicensePlate: null,
  driverVehicleId: null,
  vehicleOperatorId: null,
  acceptedAt: null,
  acceptedTimestamp: null,
  assignedByDispatcher: false,
  currentOfferDriverId: null,
  currentOfferType: null,
  currentOfferStartedAt: null,
  currentOfferExpiresAt: null,
  dispatchAction: null,
  dispatcherReleasedAt: Timestamp.now()
});
